module.exports = __webpack_public_path__ + "assets/screenfluence-loading.b851103c.svg";